import * as React from 'react';
import BackToTopButton from './BackToTopButton';
import CompanyListDataGrid from './CompanyListDataGrid';

function RankByIndustry({industry_group, data} :any) {

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">Industry Groups</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Discover Companies in your Circle of Competence</h4>
              <p className="card-description">
              <p><q>What an investor needs is the ability to correctly evaluate selected businesses. Note that word ‘selected’: You don’t have to be an expert on every company, or even many. You only have to be able to evaluate companies within your circle of competence.</q> - Warren Buffet</p>
                <p>View the highest-ranked companies in your <a href="https://en.wikipedia.org/wiki/Circle_of_competence">circle of competence</a>. We grouped all companies by their relevant industry group and ranked them.</p>
              </p>
              <div>
                <ul>
                  <li><a href='/rank_by_industry?industry_group=automobiles'>Automobiles & Components</a></li>
                  <li><a href='/rank_by_industry?industry_group=banks'>Banks</a></li>
                  <li><a href='/rank_by_industry?industry_group=capital_goods'>Capital Goods</a></li>
                  <li><a href='/rank_by_industry?industry_group=consumer_durables'>Consumer Durables & Apparel</a></li>
                  <li><a href='/rank_by_industry?industry_group=commercial_services'>Commercial & Professional Services</a></li>
                  <li><a href='/rank_by_industry?industry_group=diversified_consumer_services'>Diversified Consumer Services</a></li>
                  <li><a href='/rank_by_industry?industry_group=diversified_financials'>Diversified Financial Services</a></li>
                  <li><a href='/rank_by_industry?industry_group=energy'>Energy</a></li>
                  <li><a href='/rank_by_industry?industry_group=food_beverages_tobacco'>Food, Beverage & Tobacco</a></li>
                  <li><a href='/rank_by_industry?industry_group=food_staples'>Food & Staples Retailing</a></li>
                  <li><a href='/rank_by_industry?industry_group=health_care_equipment'>Health Care Equipment & Services</a></li>
                  <li><a href='/rank_by_industry?industry_group=hotels_restaurants'>Hotels, Restaurants & Leisure</a></li>
                  <li><a href='/rank_by_industry?industry_group=household_personal_products'>Household & Personal Products</a></li>
                  <li><a href='/rank_by_industry?industry_group=insurance'>Insurance</a></li>
                  <li><a href='/rank_by_industry?industry_group=materials'>Materials</a></li>
                  <li><a href='/rank_by_industry?industry_group=media_and_entertainment'>Media & Entertainment</a></li>
                  <li><a href='/rank_by_industry?industry_group=pharmaceuticals_biotech'>Pharmaceuticals, Biotechnology & Life Sciences</a></li>
                  <li><a href='/rank_by_industry?industry_group=real_estate'>Real Estate</a></li>
                  <li><a href='/rank_by_industry?industry_group=retailing'>Retailing</a></li>
                  <li><a href='/rank_by_industry?industry_group=software_and_services'>Software & Services</a></li>
                  <li><a href='/rank_by_industry?industry_group=semiconductors'>Semiconductors & Semiconductor Equipment</a></li>
                  <li><a href='/rank_by_industry?industry_group=technology_hardware_equipment'>Technology Hardware & Equipment</a></li>
                  <li><a href='/rank_by_industry?industry_group=telecommunication_services'>Telecommunication Services</a></li>
                  <li><a href='/rank_by_industry?industry_group=transportation'>Transportation</a></li>
                  <li><a href='/rank_by_industry?industry_group=utilities'>Utilities</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackToTopButton />
    </div>
  );
}

export default RankByIndustry;
